import React, { memo } from 'react';

import { deprecate } from 'react-is-deprecated';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import { StarRating } from 'reaxl';

function RatingBreakdown({
    className,
    layout = 'stacked',
    modalView, // deprecated
    maxRatingValue = 5,
    ratings,
    ...rest
}) {
    // handle deprecated prop
    if (modalView) {
        layout = 'horizontal';
    }

    const isHorizontal = layout === 'horizontal';

    return ratings?.length > 0 && (
        <div
            className={clsx('row', className)}
            {...rest}
        >
            {
                ratings.map(({ name, value } = {}, index) => {
                    const isEven = index % 2 === 0;
                    return (
                        <div
                            key={`ratingBreakdownWrapper-${name}`}
                            className={clsx(isHorizontal ? 'col-md-6' : 'col-xs-6')}
                        >
                            <div className={clsx(
                                'row margin-top-1 display-flex align-items-baseline ',
                                {
                                    'margin-bottom-2': isHorizontal,
                                    'flex-wrap margin-bottom-3': !isHorizontal,
                                }
                            )}
                            >
                                <div className={clsx({
                                    'col-md-offset-1': isHorizontal && !isEven,
                                    'col-xs-12': !isHorizontal,
                                    'col-xs-5 col-sm-5 col-md-4': isHorizontal,
                                })}
                                >
                                    {name}
                                </div>

                                <div className={clsx({
                                    'col-xs-12': !isHorizontal,
                                    'col-xs-7 col-sm-7 col-md-8': isHorizontal,
                                })}
                                >
                                    <StarRating
                                        className="text-size-500"
                                        color="#e8bb38"
                                        showRating
                                        value={value}
                                        uiContext="five-stars"
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}

RatingBreakdown.propTypes = {
    /**
     * Classes to add to root element
     *
     */
    className: PropTypes.string,
    /**
     * The max rating value.
     */
    maxRatingValue: PropTypes.number,
    /**
     * The view mode: in page or inside modal
     */
    modalView: deprecate(PropTypes.bool, 'modalView is deprecated. Please use the layout prop.'),
    /**
     * The layout of the label and stars: stacked or horizontal
     */
    layout: PropTypes.oneOf(['stacked', 'horizontal']),
    /**
     * The ratings array in format { name, value }.
     */
    ratings: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
    })),
};

export default memo(RatingBreakdown);
